import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import "../styles/Navbar.css";

const navLinks = [
  { path: "/", label: "Home" },
  { path: "/retreats", label: "Yoga Retreats" },
  { path: "/camping", label: "Camping" },
  { path: "/about", label: "About Us" },
  // { path: "/contactus", label: "Contact Us" },
];

function Navbar() {
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [hover, setHover] = useState(false);

  const isAuthPage =
    location.pathname === "/login" || location.pathname === "/signup";

  // Scroll detection
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };

    window.addEventListener("scroll", handleScroll, { passive: true });

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Close on Escape
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape" && menuOpen) {
        setMenuOpen(false);
      }
    };

    document.addEventListener("keydown", handleKeyDown);

    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [menuOpen]);

  // Prevent body scroll
  useEffect(() => {
    document.body.style.overflow = menuOpen ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [menuOpen]);

  if (isAuthPage) return null;

  return (
    <>
      <nav className={`pbl-navbar ${scrolled ? "pbl-navbar--scrolled" : ""}`}>
        <div className="pbl-navbar__container">

          {/* Logo */}
          <Link
            to="/"
            className="pbl-navbar__logo"
            onClick={() => setMenuOpen(false)}
            style={{
              color: "#f97316",
              transition: "color 0.3s ease",
            }}
          >
            <span className="pbl-navbar__logo-text">PlanBanaLo</span>
          </Link>

          {/* Desktop Links */}
          <div className="pbl-navbar__links">
            {navLinks.map((link) => {
              const isActive = location.pathname === link.path;

              return (
                <Link
                  key={link.path}
                  to={link.path}
                  className="pbl-navbar__link"
                  style={{
                    color: isActive
                      ? "#f97316"
                      : scrolled
                        ? "#000000"
                        : "#ffffff",
                    fontWeight: isActive ? "600" : "500",
                    transition: "color 0.3s ease",
                  }}
                >
                  {link.label}
                </Link>
              );
            })}
          </div>

          {/* Desktop Auth */}
          <div className="pbl-navbar__actions">
            <Link
              to="/contactus"
              style={{
                backgroundColor: "#f97316",
                color: "#ffffff",
                padding: "8px 16px",
                borderRadius: "6px",
                textDecoration: "none",
                fontWeight: "500",
              }}
            >
              Contact Us
            </Link>

          </div>

          {/* Hamburger */}
          <button
            className={`pbl-navbar__hamburger ${menuOpen ? "pbl-navbar__hamburger--open" : ""
              }`}
            onClick={() => setMenuOpen(!menuOpen)}
          >
            <span className="pbl-navbar__hamburger-line" />
            <span className="pbl-navbar__hamburger-line" />
            <span className="pbl-navbar__hamburger-line" />
          </button>
        </div>
      </nav>

      {/* Overlay */}
      <div
        className={`pbl-navbar__overlay ${menuOpen ? "pbl-navbar__overlay--visible" : ""
          }`}
        onClick={() => setMenuOpen(false)}
      />

      {/* Mobile Menu */}
      <div
        className={`pbl-navbar__mobile ${menuOpen ? "pbl-navbar__mobile--open" : ""
          }`}
      >
        <div className="pbl-navbar__mobile-inner">

          <div className="pbl-navbar__mobile-links">
            {navLinks.map((link, index) => {
              const isActive = location.pathname === link.path;

              return (
                <Link
                  key={link.path}
                  to={link.path}
                  className="pbl-navbar__mobile-link"
                  style={{
                    color: isActive ? "#e99356" : "#222",
                    fontWeight: isActive ? "600" : "500",
                    transitionDelay: menuOpen
                      ? `${index * 60 + 100}ms`
                      : "0ms",
                  }}
                  onClick={() => setMenuOpen(false)}
                >
                  {link.label}
                </Link>
              );
            })}
          </div>

          <div style={{ marginTop: "30px" }}>
            <Link
              to="/contactus"
              onMouseEnter={() => setHover(true)}
              onMouseLeave={() => setHover(false)}
              style={{
                backgroundColor: hover ? "#ea580c" : "#f97316",
                color: "#ffffff",
                padding: "8px 16px",
                borderRadius: "6px",
                textDecoration: "none",
                fontWeight: "500",
                transition: "all 0.3s ease",
                transform: hover ? "translateY(-2px)" : "translateY(0)",
               boxShadow: hover ? "0 10px 25px rgba(0,0,0,0.2)" : "none",
              }}
            >
              Contact Us
            </Link>


          </div>

        </div>
      </div>
    </>
  );
}

export default Navbar;